import React from "react";
import SingleCollection from "./single";
import MultipleCollections from "./multiple";


const FeaturedCollection = ({ data }) => {
	const { collection, relatedcollections, showCollections } = data || {};

	if (showCollections && relatedcollections ) {
		return <MultipleCollections data={data} />;
	} else if (collection) {
		return <SingleCollection data={data} />;
	}

	return null;
};

export default FeaturedCollection;
